import { makeStyles } from '@material-ui/core';
import logo from '../../assets/bobbee-logo.png';

const useStyles = makeStyles({
  mark: {
    display: 'block',
    height: 40,
    width: 'auto',
    flexShrink: 0,
  },
});

/** Bobbee "B" with the bee (transparent PNG, readable on the teal sidebar). */
export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.mark} src={logo} alt="" aria-hidden="true" />;
};
